"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AcTableCheckDropdown = void 0;
var React = __importStar(require("react"));
var AcDropdown_1 = require("../dropdown/AcDropdown");
var FaIcon_1 = require("../util/FaIcon");
var AcTableCheckDropdown = function (_a) {
    var _b = _a.selectedRowIds, selectedRowIds = _b === void 0 ? [] : _b, onClickSelectedPageCheckAll = _a.onClickSelectedPageCheckAll, disabledSelectedPageCheckAll = _a.disabledSelectedPageCheckAll, onClickSelectedPageUncheckAll = _a.onClickSelectedPageUncheckAll, disabledSelectedPageUncheckAll = _a.disabledSelectedPageUncheckAll, 
    // onClickAllPageCheckAll,
    // disabledAllPageCheckAll,
    onClickAllPageUncheckAll = _a.onClickAllPageUncheckAll, disabledAllPageUncheckAll = _a.disabledAllPageUncheckAll;
    var selectedPageCheckAll = {
        name: 'ページ内の項目をすべて選択する',
        title: function () { return (React.createElement("span", { className: "d-flex align-items-center fs-small" },
            React.createElement("span", { className: "fa-stack fa-fw fs-10 mr-1" },
                React.createElement("i", { className: "fas fa-check fa-stack-1x", style: { fontSize: 8, top: 1 } }),
                React.createElement("i", { className: "far fa-clipboard fs-20 fa-stack-1x" })),
            "\u30DA\u30FC\u30B8\u5185\u306E\u9805\u76EE\u3092\u3059\u3079\u3066\u9078\u629E\u3059\u308B")); },
        icon: 'fal fa-clipboard-check',
        onClick: onClickSelectedPageCheckAll,
        disabled: disabledSelectedPageCheckAll,
    };
    var selectedPageUncheckAll = {
        name: 'ページ内の項目をすべて解除する',
        title: function () { return (React.createElement("span", { className: "d-flex align-items-center fs-small" },
            React.createElement("span", { className: "fa-stack fa-fw fs-10 mr-1" },
                React.createElement("i", { className: "fas fa-sync-alt fa-stack-1x", style: { fontSize: 8, top: 1 } }),
                React.createElement("i", { className: "far fa-clipboard fs-20 fa-stack-1x" })),
            "\u30DA\u30FC\u30B8\u5185\u306E\u9805\u76EE\u3092\u3059\u3079\u3066\u89E3\u9664\u3059\u308B")); },
        icon: 'fal fa-clipboard',
        onClick: onClickSelectedPageUncheckAll,
        disabled: disabledSelectedPageUncheckAll,
    };
    var allPageUncheckAll = {
        name: 'すべて解除する',
        title: function () { return (React.createElement("span", { className: "d-flex align-items-center fs-small" },
            React.createElement("span", { className: "fa-stack fa-fw fs-10 mr-1" },
                React.createElement("i", { className: "fas fa-sync-alt fs-14 fa-stack-1x" })),
            "\u3059\u3079\u3066\u89E3\u9664\u3059\u308B")); },
        onClick: onClickAllPageUncheckAll,
        disabled: disabledAllPageUncheckAll,
    };
    return (React.createElement(AcDropdown_1.AcDropdown, { title: React.createElement(React.Fragment, null,
            React.createElement("span", null,
                React.createElement("input", { type: "checkbox", className: "custom-control-input", defaultChecked: true, readOnly: true }),
                React.createElement("span", { className: "mr-1 position-relative" },
                    React.createElement(FaIcon_1.FaIcon, { icon: "far fa-check", size: "default", variant: selectedRowIds.length > 0 ? 'primary' : undefined, fixedWidth: true }),
                    selectedRowIds.length > 0 && (React.createElement("i", { className: "fas fa-circle fa-fw text-attention position-absolute", style: { top: '-1px', right: '-3px', fontSize: 4 } }))),
                selectedRowIds.length > 0 && (React.createElement(React.Fragment, null,
                    "\u7D2F\u8A08",
                    selectedRowIds.length,
                    "\u4EF6\u3092\u9078\u629E\u4E2D")))), align: "left", actions: [selectedPageCheckAll, selectedPageUncheckAll, allPageUncheckAll], data: [], toggleSize: "sm", toggleVariant: "sub4", toggleActive: selectedRowIds.length > 0, toggleClassName: "pl-1" }));
};
exports.AcTableCheckDropdown = AcTableCheckDropdown;
exports.AcTableCheckDropdown.displayName = 'AcTableCheckDropdown';
//# sourceMappingURL=AcTableCheckDropdown.js.map